import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {backIcon, closeIcon} from '~/constants/InlineSvgs';
import Menu from '~/shared/components/Menu';
import MenuButton from '~/shared/components/MenuButton';
import {Typography} from '@customink/pigment-react';

import './index.scss';

const propTypes = {
  backText: PropTypes.string,
  className: PropTypes.string,
  confirm: PropTypes.bool,
  contextualToolsOpen: PropTypes.bool,
  domRef: PropTypes.func,
  isNamesNumbersNav: PropTypes.bool,
  isRemovable: PropTypes.bool,
  next: PropTypes.bool,
  noBack: PropTypes.bool,
  showBackIconAndText: PropTypes.bool,
  title: PropTypes.string,
  onBack: PropTypes.func,
  onClose: PropTypes.func
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const NavHeader = props => {
  const classes = classnames('ndx-title', 'ndx-NavHeader', props.className);
  let leftButton;

  const closeProps = props.confirm
    ? {
        text: props.next ? 'Next' : 'Done'
      }
    : {
        icon: closeIcon
      };
  const rightButton = (
    <MenuButton
      {...closeProps}
      key="close"
      className="ndx-NavHeader-close"
      onClick={props.onClose}
    />
  );

  if (props.noBack) {
    leftButton = null;
  } else {
    let backProps = props.isRemovable ? {text: 'Remove'} : {icon: backIcon};
    let className = 'ndx-NavHeader-back';

    if (props.showBackIconAndText) {
      backProps = {...backProps, ...{text: props.backText || 'Back'}};
      className = classnames(className, 'backIconAndText');
    }

    leftButton = (
      <MenuButton
        {...backProps}
        key="back"
        className={className}
        onClick={props.onBack}
      />
    );
  }

  const titleClassname = classnames('ndx-NavHeader-title', {
    'ndx-NavHeader-title--isNamesAndNumbers': props.isNamesNumbersNav
  });

  return (
    <Menu className={classes} domRef={props.domRef}>
      {leftButton}
      <Typography
        component="h5"
        variant="uiTextSmall"
        className={titleClassname}>
        {props.title}
      </Typography>
      {rightButton}
    </Menu>
  );
};

NavHeader.propTypes = propTypes;

NavHeader.defaultProps = {
  confirm: false,
  noBack: false
};

NavHeader.displayName = 'NavHeader';

export default NavHeader;
